import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'

import EmbeddedDealPage from 'containers/EmbeddedDealPage'
import EmbeddedCompanyPage from 'containers/EmbeddedCompanyPage'
import EmbeddedNda from 'containers/SupplierProfile/components/EmbeddedNda'

export default ({ history }) => (
  <Router history={history}>
    <Switch>
      <Route path="/embedded/deal/:dealId" component={EmbeddedDealPage} />
      <Route path="/embedded/company/:companyId" component={EmbeddedCompanyPage} />
      <Route path="/embedded/supplier/:supplierId/nda" component={EmbeddedNda} />
    </Switch>
  </Router>
)
